export default __webpack_public_path__ + "static/media/footerbackimg.7859f153.png";